<template>
<div>
  
<div class="md:flex justify-between py-20 px-10">
  <div class="md:w-1/2 mb-10 md:mb-0">
    <h2 class="text-2xl text-gray-800 md:text-4xl lg:text-6xl mb-6 px-3">{{property.title}}</h2>
    <blockquote class="mb-6 px-3">
    <p>"Dogs do speak, but only to those who know how to listen"</p>
      <footer><cite>Orhan Pamuk</cite></footer>
      <p class="p-6">Samoyeds are happy dogs, or so it seems due to their constantly smiling face. This breed has been given the moniker ‘Sammy smile’ because of this feature. These dogs are amazing to be around with because they are full of energy and very loving. But these dogs need training, as they can become obstinate, talkative, and destructive. They are very good with children, making them the perfect family dog. Samoyeds are known for their gentleness and loyalty. They are not ferocious at all, but they still make very good guard dogs. Samoyeds love being around people and other dogs, and if left alone, they become sad. They choose one member of the family, usually the one who feeds it and is more attached to him/her.--><p/>
      </blockquote>
    <a href="#" class="px-4 py-3 text-lg bg-red-600 rounded text-red-200 mr-2 hover:text-red-100">Learn More</a>
  </div>
  
  <div class="md:w-1/2">
    <img :src="property.imageUrl" :alt="property.imageAlt" class="w-full rounded shadow-2xl" loading="lazy">
  </div>
</div>  


<div class="md:flex px-10 py-16 bg-red-600">
  <div class="photo mr-2 text-center mt-8">
    <img :src="property.imageOne" :alt="property.imageAlt" class="image">
    <p class="text">
      <a href="#">Breeds</a>
    </p>
  </div>
  <div class="photo mr-2 text-center">
    <img :src="property.imageTwo" :alt="property.imageAlt" class="image">
    <p class="text">Fun Facts</p>
  </div>
  <div class="photo mr-2 text-center mt-8">
    <img :src="property.imageThree" :alt="property.imageAlt" class="image">
    <p class="text">Stories</p>
  </div>
  <div class="photo mr-2 text-center">
    <img :src="property.imageFour" :alt="property.imageAlt" class="image">
    <p class="text">Guides</p>
  </div> 
</div>
</div>
    
</template>

<script>
export default {
  data:() => ({
    property: {
      imageUrl: "https://images.fineartamerica.com/images/artworkimages/mediumlarge/1/portrait-of-samoyed-dog-on-white-background-sergey-taran.jpg",
      imageAlt: "A photo of a dog",
      title: "All About Puppies",
      imageOne: "https://patch.com/img/cdn20/users/23306266/20200701/034325/styles/patch_image/public/cute-dogs___01153249063.jpg",
      imageTwo: "https://images.unsplash.com/photo-1587027077233-c7a2e15825cf?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=652&q=80",
      imageThree: "https://images.unsplash.com/photo-1551147239-144f237a37b3?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=750&q=80",
      imageFour: "https://images.unsplash.com/photo-1541336187922-bffa4ef13d45?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=750&q=80"
    }
  })
}
</script>

<style scoped>
  .image{
     @apply 
     w-full 
     mb-4 
     rounded 
     border-solid 
     border-2 
     border-red-200
   }


   .photo{
     transition: all .9s ease .1s;
   }

   .photo:hover{
     transform: translateY(-24px);
     cursor: pointer;
     filter:opacity(80%);
     
   }

   .text{
     @apply 
     text-red-200
   }



</style>
